import { render, staticRenderFns } from "./_security-matrix.vue?vue&type=template&id=7e5d9e58"
import script from "./_security-matrix.vue?vue&type=script&lang=js"
export * from "./_security-matrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports